document.addEventListener("DOMContentLoaded", function() {
  const subPriceSpan = document.querySelector(".subscription-message");

  if (subPriceSpan && subPriceSpan.textContent.trim() === "") {
    let currentPrice = null;

    // Try getting current price from Alpine.js or meta.product
    if (window.Alpine) {
      const productEl = document.querySelector("[x-data]");
      if (productEl && productEl.__x) {
        const alpineComponent = productEl.__x.$data;
        if (alpineComponent.current_price) {
          currentPrice = alpineComponent.current_price;
        } else if (alpineComponent.current_variant && alpineComponent.current_variant.price) {
          currentPrice = alpineComponent.current_variant.price;
        }
      }
    }

    if (!currentPrice && window.meta && window.meta.product) {
      currentPrice = window.meta.product.variants[0].price;
    }

    if (currentPrice !== null) {
      const priceNum = typeof currentPrice === "number" ? currentPrice / 100 : parseFloat(currentPrice);

      // Assume subscription discount = difference between one-time and subscription price if available
      // Since Recharge hides one-time price, we'll use a fixed percentage (e.g. 10%) OR detect it if you have both
      const discountPercent = 10; // adjust if needed, or we can make it dynamic
      const discountedPrice = priceNum * (1 - discountPercent / 100);

      const formattedRegular = `$${priceNum.toFixed(2)}`;
      const formattedDiscounted = `$${discountedPrice.toFixed(2)}`;

      subPriceSpan.innerHTML = `
        <span class="line-through opacity-70 mr-2">${formattedRegular}</span>
        <span class="text-green-700 font-semibold">${formattedDiscounted}</span>
      `;
    }
  }
});
